

import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Github, Twitter, Linkedin, Mail } from 'lucide-react';

export function Footer() {
  return (
    <footer className="relative bg-card/50">
      <div className="relative pt-20 pb-10 px-4">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-8 mb-16">
            <div className="col-span-2 lg:col-span-2">
              <Link to="/" className="inline-block mb-6">
                <svg xmlns="http://www.w3.org/2000/svg" xmlSpace="preserve" x="0" y="0" version="1.1" viewBox="0 0 471.9 123.4" className="h-6 w-auto fill-foreground">
                  <path d="M296.1 26.6c-3.1.2-6.2 0-9.5 0v-10c3.2-1.2 5.5-4.4 5.5-8 0-4.7-3.8-8.6-8.6-8.6-4.7 0-8.6 3.8-8.6 8.6 0 3.7 2.4 6.9 5.7 8.1v10h-15.4c-6.9.1-13.5 1.5-19.3 5.5-10.9 7.6-13.6 18.4-13.4 31 .4 19.9 12.9 32.9 32.7 33 12.3.1 24.6.2 37-.1 4.3-.1 8.7-.8 12.7-2.2 11.9-4.2 18.9-15.7 19.8-28.5 1.7-26.7-14.5-40.7-38.6-38.8zm25 39.9c-.8 9.1-7 14.8-16.2 14.8h-21.5c-7.3 0-14.7.1-22 0-8-.1-13.8-5.2-15.2-13.1-.2-1.3-.3-2.6-.4-4-1.1-15.4 4.3-23.9 22.4-23.1 12 .6 24 .1 36 .1 10.4.1 16.8 6.3 17.1 16.7 0 3 0 5.8-.2 8.6zm-22.8 35.9c-5.3 2.4-9.9 4.4-14.4 6.4-.3.1-.6.1-.8 0-4.6-2.1-9.2-4.1-14.4-6.4-.7-.3-1.4.2-1.4.9v19.1c0 .7.8 1.2 1.4.9 5.3-2.3 9.9-4.4 14.5-6.4.3-.1.6-.1.8 0 4.7 2.1 9.2 4.1 14.4 6.4.7.3 1.4-.2 1.4-.9v-19.1c-.1-.8-.8-1.2-1.5-.9z"/>
                  <path d="M300.8 54.8c-1.8 0-3.4.7-4.7 1.9l-.3.3c-1.1 1.2-1.7 2.8-1.7 4.5 0 3.7 3 6.7 6.7 6.7s6.7-3 6.7-6.7-3-6.7-6.7-6.7z"/>
                  <circle cx="266.2" cy="61.5" r="6.7"/>
                  <path d="M68.2 29.5h15.4v65.1H68.4l-.8-9.6c-3.7 7.7-13.9 11.4-21.1 11.5C27.3 96.7 13 84.8 13 61.9c0-22.4 14.9-34.2 33.9-34.1 8.7 0 17 4.1 20.7 10.6l.6-8.9zM29.1 61.9c0 12.4 8.6 19.8 19.3 19.8 25.3 0 25.3-39.5 0-39.5-10.7.1-19.3 7.3-19.3 19.7zM91 44.6v28.1c0 16.2 9.2 24.3 23.4 23.8 2.7-.1 5-.3 7.4-.9v-15c-2 .8-4.3 1.3-6.3 1.3-5.1-.1-8.5-3.1-8.5-9.3V44.5h13.3V30.6h-13.2V13.9H91v30.7zm93.9-15.3 14.3 49 14.9-49h17.8l-22.7 65.5h-18.7l-6.7-19.3-5.8-21.8-5.8 21.8-6.7 19.3h-18.7L124 29.3h18l14.9 49 14.1-49h13.9zm175 .2 1.2 7.5c5-8.1 11.7-9.2 18.3-9.2 6.7 0 13.2 2.6 16.8 6.2L389 48c-3.3-2.8-6.3-4.2-11.6-4.2-8.4 0-16.2 4.5-16.2 16.5v34.3H345V29.5h14.9zM418 2.3v53.3l21.9-26.1h19.3v.9l-26.5 29.7 30.2 33.3v1.2h-19.4L418 65.1v29.4h-16.1V2.3H418z"/>
                </svg>
              </Link>
              <p className="text-muted-foreground mb-6 max-w-sm">
                The AI-powered workspace that transforms how modern teams work, communicate, and grow their business.
              </p>
              <div className="flex space-x-4">
                <Link to="#" className="p-3 bg-accent hover:bg-yellow-400 hover:text-neutral-900 text-muted-foreground rounded-lg transition-colors">
                  <Github className="w-5 h-5" />
                </Link>
                <Link to="#" className="p-3 bg-accent hover:bg-yellow-400 hover:text-neutral-900 text-muted-foreground rounded-lg transition-colors">
                  <Twitter className="w-5 h-5" />
                </Link>
                <Link to="#" className="p-3 bg-accent hover:bg-yellow-400 hover:text-neutral-900 text-muted-foreground rounded-lg transition-colors">
                  <Linkedin className="w-5 h-5" />
                </Link>
                <Link to="#" className="p-3 bg-accent hover:bg-yellow-400 hover:text-neutral-900 text-muted-foreground rounded-lg transition-colors">
                  <Mail className="w-5 h-5" />
                </Link>
              </div>
            </div>

            <div className="col-span-1">
              <h4 className="font-semibold text-foreground mb-6">Product</h4>
              <div className="space-y-3">
                <p><Link to="#" className="text-muted-foreground hover:text-yellow-400 transition-colors">Features</Link></p>
                <p><Link to="/pricing" className="text-muted-foreground hover:text-yellow-400 transition-colors">Pricing</Link></p>
                <p><Link to="#" className="text-muted-foreground hover:text-yellow-400 transition-colors">Integrations</Link></p>
                <p><Link to="#" className="text-muted-foreground hover:text-yellow-400 transition-colors">API</Link></p>
              </div>
            </div>

            <div className="col-span-1">
              <h4 className="font-semibold text-foreground mb-6">Company</h4>
              <div className="space-y-3">
                <p><Link to="#" className="text-muted-foreground hover:text-yellow-400 transition-colors">About us</Link></p>
                <p><Link to="#" className="text-muted-foreground hover:text-yellow-400 transition-colors">Blog</Link></p>
                <p><Link to="#" className="text-muted-foreground hover:text-yellow-400 transition-colors">Careers</Link></p>
                <p><Link to="#" className="text-muted-foreground hover:text-yellow-400 transition-colors">Contact</Link></p>
              </div>
            </div>

            <div className="col-span-1">
              <h4 className="font-semibold text-foreground mb-6">Resources</h4>
              <div className="space-y-3">
                <p><Link to="#" className="text-muted-foreground hover:text-yellow-400 transition-colors">Help Center</Link></p>
                <p><Link to="#" className="text-muted-foreground hover:text-yellow-400 transition-colors">Guides</Link></p>
                <p><Link to="#" className="text-muted-foreground hover:text-yellow-400 transition-colors">Webinars</Link></p>
                <p><Link to="#" className="text-muted-foreground hover:text-yellow-400 transition-colors">Community</Link></p>
              </div>
            </div>

            <div className="col-span-2 lg:col-span-1">
              <h4 className="font-semibold text-foreground mb-6">Stay updated</h4>
              <p className="text-muted-foreground mb-4 text-sm">
                Get the latest news and updates from atWork.ai
              </p>
              <form className="space-y-3">
                <input
                  type="email"
                  placeholder="Enter your email"
                  className="w-full px-4 py-3 bg-accent border border-border rounded-lg text-foreground placeholder-muted-foreground focus:border-yellow-400 focus:ring-yellow-400 focus:ring-1 transition-colors"
                />
                <Button className="w-full bg-yellow-400 text-neutral-900 hover:bg-yellow-300 rounded-lg font-semibold">
                  Subscribe
                </Button>
              </form>
            </div>
          </div>

          <div className="pt-8 border-t border-border">
            <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
              <div className="flex items-center space-x-6">
                <p className="text-sm text-muted-foreground">© 2025 atWork.ai. All rights reserved.</p>
                <div className="hidden md:flex items-center space-x-6">
                  <Link to="#" className="text-sm text-muted-foreground hover:text-yellow-400 transition-colors">Privacy Policy</Link>
                  <Link to="#" className="text-sm text-muted-foreground hover:text-yellow-400 transition-colors">Terms of Service</Link>
                  <Link to="#" className="text-sm text-muted-foreground hover:text-yellow-400 transition-colors">Cookie Policy</Link>
                </div>
              </div>
              <div className="flex items-center space-x-2">
                <div className="w-2 h-2 bg-green-400 rounded-full animate-pulse"></div>
                <span className="text-sm text-muted-foreground">All systems operational</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

